// Canonical list of offerte types used by the wizard and by the B2B signup form.
// Keep in sync with backend defaults (no hard validation server-side — admin
// can also accept on-demand niches if a partner emails us).
export const OFFERTE_TYPES = [
  "Renovatie & Bouw",
  "Schilderwerk",
  "Sanitair",
  "Elektriciteit",
  "Tuin & Buiten",
  "Verwarming & Energie",
  "Autoreparatie",
  "Verhuis",
  "Schoonmaak",
];
